export interface MenuItem {
  id: string;
  labelKey: string;
  path: string;
  permission?: string;
  requireAdmin?: boolean;
  /** Which submenu section this belongs to */
  section: string;
}

/**
 * Static registry of all pinnable sidebar menu items.
 * Order here determines the order pinned shortcuts appear.
 * Calendar is NOT included — it's always visible and not pinnable.
 */
export const menuItems: MenuItem[] = [
  // Events section
  { id: 'events-all', labelKey: 'sidebar.allEvents', path: '/admin/events', permission: 'events:read', section: 'events' },
  { id: 'events-templates', labelKey: 'sidebar.eventTemplates', path: '/admin/event-templates', permission: 'events:read', section: 'events' },
  { id: 'events-invitations', labelKey: 'sidebar.eventInvitations', path: '/admin/invitations', permission: 'events:read', section: 'events' },
  { id: 'events-open', labelKey: 'sidebar.publicEvents', path: '/admin/open-events', permission: 'events:read', section: 'events' },

  // Activities section
  { id: 'activities-list', labelKey: 'sidebar.activities', path: '/admin/activities', permission: 'activities:read', section: 'activities' },
  { id: 'activities-courses', labelKey: 'sidebar.courses', path: '/admin/courses', permission: 'activities:read', section: 'activities' },
  { id: 'activities-sections', labelKey: 'sidebar.sections', path: '/admin/sections', permission: 'activities:read', section: 'activities' },

  // People section
  { id: 'people-members', labelKey: 'sidebar.members', path: '/admin/members', permission: 'members:read', section: 'people' },
  { id: 'people-users', labelKey: 'sidebar.users', path: '/admin/users', permission: 'users:read', section: 'people' },
  { id: 'people-groups', labelKey: 'sidebar.groups', path: '/admin/groups', permission: 'groups:read', section: 'people' },
  { id: 'people-approvals', labelKey: 'sidebar.approvals', path: '/admin/approvals', permission: 'members:write', section: 'people' },

  // Communication section
  { id: 'communication-center', labelKey: 'sidebar.communication', path: '/admin/communication', section: 'communication' },
  { id: 'communication-announcements', labelKey: 'sidebar.announcements', path: '/admin/announcements', permission: 'announcements:read', section: 'communication' },

  // Finance section
  { id: 'finance-memberships', labelKey: 'sidebar.memberships', path: '/admin/memberships', permission: 'memberships:read', section: 'finance' },
  { id: 'finance-payment-overview', labelKey: 'sidebar.paymentOverview', path: '/admin/payments/overview', permission: 'payments:read', section: 'finance' },
  { id: 'finance-payment-import', labelKey: 'payments.importTitle', path: '/admin/payments/import', permission: 'payments:read', section: 'finance' },

  // Reports section
  { id: 'reports-statistics', labelKey: 'sidebar.statistics', path: '/admin/statistics', permission: 'statistics:read', section: 'reports' },
  { id: 'reports-attendance', labelKey: 'sidebar.attendanceReports', path: '/admin/attendance', permission: 'statistics:read', section: 'reports' },

  // Settings section
  { id: 'settings-organization', labelKey: 'sidebar.orgSettings', path: '/admin/organization', requireAdmin: true, section: 'settings' },
  { id: 'settings-preferences', labelKey: 'sidebar.preferences', path: '/admin/preferences', requireAdmin: true, section: 'settings' },
  { id: 'settings-roles', labelKey: 'sidebar.roles', path: '/admin/roles', permission: 'roles:read', requireAdmin: true, section: 'settings' },
  { id: 'settings-requirement-types', labelKey: 'sidebar.requirementTypes', path: '/admin/requirement-types', permission: 'requirements:read', requireAdmin: true, section: 'settings' },
  { id: 'settings-billing', labelKey: 'sidebar.billing', path: '/admin/billing', requireAdmin: true, section: 'settings' },
];

/** Look up a menu item by its ID */
export const getMenuItem = (id: string): MenuItem | undefined =>
  menuItems.find(item => item.id === id);
